import React from 'react';
import { AxiosResponse } from 'axios';
import { getColumns } from './FilterBuilder.Grid';
import actionItemHelper from '../../../../infrastructure/helpers/actionItem/actionItemHelper';
import ActionItemSaveRequest from '../../../../types/common/ActionItem/ActionItemSaveRequest';
import actions from '../../../../store/actions';
import ComplianceComment from '../../../../types/common/ComplianceComment';
import complianceCommentHelper from '../../../../infrastructure/helpers/complianceComment/complianceCommentHelper';
import ConditionBuilder from '../../../Functions/Condition/ConditionBuilder';
import conditionDisplayHelper from '../../../../infrastructure/helpers/functions/condition/conditionDisplayHelper';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import locationType from '../../../../types/functions/Location/LocationType';
import reportConfigNavigation from '../../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import ReportLogicList from '../../Common/ReportLogicList/ReportLogicList';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import StatementBuilderProps from '../../../Functions/Statement/StatementBuilderProps';
import store from '../../../../store/store';
import urlHelper from '../../../../infrastructure/helpers/common/urlHelper';
import Condition from '../../../../types/functions/Condition/Condition';
import identityStorage from '../../../../infrastructure/authorization/identityStorage';
import ActionitemDto from '../../../../types/common/ActionItem/ActionItemDto';
import ActionItemDto from '../../../../types/common/ActionItem/ActionItemDto';
import { reportType } from '../../../../infrastructure/constants/reportType';
import DragAndDropItem from '../../../../types/report/DragAndDropItem';
import reorderHelper from '../../../../infrastructure/helpers/common/reorderHelper';
import ReportFilter from '../../../../types/report/ReportFilter';
import reportComponentBuildersHelper from '../../Common/ReportComponentsHelper';
import ComponentType from '../../../../types/report/ComponentType';
import BespokeConditionBuilder from '../../../Functions/Bespoke/BespokeConditionBuilder';
import ReportComponentStatus from '../../Common/ReportComponentStatus/ReportComponentStatus';
import ErrorList from '../../../Common/ErrorList/ErrorList';
import InsertAtPositionModal from '../../../Common/Modals/InsertAtPositionModal/InsertAtPositionModal';
import IdNameAndNumber from '../../../../types/report/IdNameAndNumber';
import ActionType from '../../../../types/report/ActionType';
import { SelectSearchOption } from 'react-select-search';
import assignmentHelper from '../../../../infrastructure/helpers/functions/assignment/assignmentHelper';

class FilterBuilder extends React.Component<StatementBuilderProps<ReportFilter>, { showPopup: boolean }> {
    constructor(props: StatementBuilderProps<ReportFilter>) {
        super(props);

        this.state = {
            showPopup: false
        }

        this.onNameChange = this.onNameChange.bind(this);
        this.onBusinessDescriptionChange = this.onBusinessDescriptionChange.bind(this);
        this.onBespokeToggleClick = this.onBespokeToggleClick.bind(this);
        this.onCommentClick = this.onCommentClick.bind(this);
        this.onActionItemClick = this.onActionItemClick.bind(this);
        this.onGetCommentSuccess = this.onGetCommentSuccess.bind(this);
        this.onGetActionItemDataSuccess = this.onGetActionItemDataSuccess.bind(this);
        this.getCommentCount = this.getCommentCount.bind(this);
        this.getActionItemCount = this.getActionItemCount.bind(this);
        this.getConditionContent = this.getConditionContent.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
        this.onAddFilterClick = this.onAddFilterClick.bind(this);
        this.validateInsertBeforeAfter = this.validateInsertBeforeAfter.bind(this);
        this.prepareOptionsFromFilters = this.prepareOptionsFromFilters.bind(this);
        this.onAddFilterClick = this.onAddFilterClick.bind(this);
        this.onFilterConfiguredInPopup = this.onFilterConfiguredInPopup.bind(this);
        this.prepareOptionsFromFilters = this.prepareOptionsFromFilters.bind(this);
        this.onClearClick = this.onClearClick.bind(this);
        this.onDropBetweenFilters = this.onDropBetweenFilters.bind(this);
        this.reorder = this.reorder.bind(this);
    }

    onNameChange(name: string, number: number): void {

        this.props.onStatementChange({ number: number, name: name } as ReportFilter);
    }

    onBusinessDescriptionChange(businessDescription: string, number: number): void {

        this.props.onStatementChange({ number: number, businessDescription: businessDescription } as ReportFilter);
    }

    onBespokeToggleClick(isBespoke: boolean, filter: ReportFilter): void {

        let changes = { number: filter.number, isBespoke: isBespoke } as ReportFilter;

        if (isBespoke) {
            changes.bespokeCondition = conditionDisplayHelper.buildConditions(filter.condition, this.props.reportConfig.lookups, this.props.reportConfig.dictionaries, this.props.reportConfig.variables,
                this.props.collections.dataSources, [], this.props.collections.customDataSourceFields, this.props.reportConfig.type);
        }

        this.props.onStatementChange(changes);
    }

    onCommentClick(id: number): Promise<any> {

        let url = urlHelper.buildRoute(['filter-comment', id]);

        return httpClient.get<ComplianceComment[]>(url).then(response => this.onGetCommentSuccess(response.data, url));
    }

    onActionItemClick(id: number): Promise<any> {

        let identity = identityStorage.get();

        let allItemsForClient = urlHelper.buildRoute(['action-item', 'by-client-id']);

        let filterActionItems = urlHelper.buildRoute(['action-item', 'filter', id]);

        let buildRelationUrl = (actionItemId: string) => urlHelper.buildRoute(['action-item', actionItemId, 'filter', id]);

        let calls: [Promise<AxiosResponse<ActionitemDto[]>>, Promise<AxiosResponse<ActionitemDto[]>>] = [httpClient.get<ActionitemDto[]>(allItemsForClient, { reportConfigId: this.props.reportConfig.id, clientId: identity.clientId || null }), httpClient.get<ActionitemDto[]>(filterActionItems)];

        let saveRequest = { reportConfigId: this.props.reportConfig.id, filterId: id } as ActionItemSaveRequest;

        return Promise.all(calls).then(responses => {
            this.onGetActionItemDataSuccess(responses[0].data, responses[1].data, saveRequest, buildRelationUrl)
        });
    }

    onGetCommentSuccess(comments: ComplianceComment[], url: string): void {

        let state = complianceCommentHelper.createModalState(comments, url);

        store.dispatch({ type: actions.complianceCommentModal.open, payload: state });
    }

    onGetActionItemDataSuccess(allActionItems: ActionItemDto[], filterActionItems: ActionItemDto[], saveRequest: ActionItemSaveRequest, buildRelationUrl: (actionItemId: string) => string): void {

        let originalActionItems: ActionItemDto[] = [];
        allActionItems.forEach((iten) => {
            originalActionItems.push(Object.assign({}, iten));
        });

        const filterItems = actionItemHelper.prepareModuleActionitems(allActionItems, filterActionItems);

        let state = actionItemHelper.createModalState(originalActionItems, allActionItems, filterItems, saveRequest, buildRelationUrl, 'Filter');

        store.dispatch({ type: actions.actionItemModal.open, payload: state });
    }

    getCommentCount(id: number): number {

        return this.props.counts.filterCommentCounts[id.toString()] || 0;
    }

    getActionItemCount(id: number): number {

        return this.props.counts.filterActionItemCounts[id.toString()] || 0;
    }

    onReorderConditions(condition: Condition, filter: ReportFilter) {

        filter.condition = condition;
        this.props.onStatementChange(filter);
    }

    async tryLock(number?: number, filter?: ReportFilter): Promise<boolean> {

        if (this.props.reportConfig.type === reportType.accuracy && this.props.onComponentContainerClick) {

            let currentfilter = filter || this.props.reportConfig.filters.find(v => v.number === number);
            if (!currentfilter?.isUsedByCurrentUser) {
                return await this.props.onComponentContainerClick({ componentId: currentfilter?.id || 0, componentType: ComponentType.Lookup, number: currentfilter?.number || 0 });
            }
        }
        return false;
    }

    async onClearClick(condition: Condition, filter: ReportFilter): Promise<void> {

        let isLocked = await this.tryLock(undefined, filter);

        if (!isLocked) {
            let newFilter = assignmentHelper.clearOperandsInStatementByConditionNumber(condition.number, filter) as ReportFilter;

            this.props.onStatementChange(newFilter);
        }
    }

    onStatusChange(status: string, number: number) {
        this.props.onStatementChange({ number, status } as ReportFilter);
    }

    async reorder(dragNumber: number, dropNumber: number): Promise<void> {

        let dragIndex = this.props.reportConfig.filters.findIndex(x => x.number === dragNumber);
        let dropIndex = this.props.reportConfig.filters.findIndex(x => x.number === dropNumber);

        let draggedFilter = this.props.reportConfig.filters.find(v => v.number === dragNumber) as ReportFilter;
        let dropFilter = this.props.reportConfig.filters.find(v => v.number === dropNumber) as ReportFilter;

        this.clearAllErrors();

        let result = reportComponentBuildersHelper.validateDragAndDrop(draggedFilter as DragAndDropItem, dropFilter as DragAndDropItem, ComponentType.Filter);

        if (result.error) {
            const filterReferenced = this.props.statements.find(s => s.number === result.number) || {} as ReportFilter;

            result.error = `${result.error} The referenced filter is "${filterReferenced.name}".`;

            const number = result.isDrag ? draggedFilter.number : dropFilter.number;

            const statement = this.props.statements.find(s => s.number === number) || {} as ReportFilter;

            statement.errors = [result.error];

            this.props.onStatementChange(statement);

            return;
        }
        else {

            reorderHelper.reorderWithNumbersChange(this.props.reportConfig.filters, dragIndex, dropIndex);

            this.props.reorder(dragNumber, dropNumber);
        }
    }

    async onFilterConfiguredInPopup(name: string, type: string, isInsertAfter: boolean, selectedLookupNumber: string): Promise<void> {
        this.setState({ showPopup: false });
        const insertionAfterLookupNumber: number = parseInt(selectedLookupNumber);

        this.props.onAddStatementClick(name, (filter, filters) => {
            filters = reorderHelper.rearangeElementsWhenAddNewOne(filters, filter, isInsertAfter, insertionAfterLookupNumber) as ReportFilter[];
            if (!name) {
                let number = filters.map(v => v.number).sort((x, y) => { return x > y ? 1 : x < y ? -1 : 0; }).pop() || 0;
                filter.name = `filter-${number}`;
                filter._internalId = filter.number;
            }
            else {
                filter.name = name
            }
        });
    }

    clearAllErrors() {
        this.props.reportConfig.filters.forEach((filter) => {
            filter.errors = [];
        });
    }

    onDropBetweenFilters(dragNumber: number, dropNumber: number) {

        let numbersMap = reorderHelper.prepareNewNumbersMapOnDragBetween(dragNumber, dropNumber);

        this.props.onDragStatementBetween && this.props.onDragStatementBetween(numbersMap);
    }

    getConditionContent(filter: ReportFilter): JSX.Element {

        if (filter.isBespoke) {
            return (
                <BespokeConditionBuilder
                    keyword={this.props.details.keyword}
                    keyword2={this.props.details.keyword2}
                    statement={filter}
                    onChange={this.props.onStatementChange}
                    isReadOnly={this.props.isReadOnly} />
            );
        }

        return (
            <>
                <ConditionBuilder
                    reportConfigType={this.props.reportConfig.type}
                    isReadOnly={this.props.isReadOnly}
                    allowCopy={true}
                    keyword={this.props.details.keyword}
                    functions={this.props.reportConfig.userDefinedFunctions}
                    globalFunctions={this.props.collections.globalModuleConfig.userDefinedFunctions}
                    lookups={this.props.reportConfig.lookups}
                    dictionaries={this.props.reportConfig.dictionaries}
                    dataSources={this.props.collections.dataSources}
                    variables={this.props.reportConfig.variables}
                    reportFields={this.props.reportConfig.type === reportType.accuracy ? this.props.collections.reportFields : []}
                    customDataSourceFields={this.props.collections.customDataSourceFields}
                    location={{ statement: locationType.statement.filter, statementNumber: filter.number } as ReportLogicLocation}
                    condition={filter.condition}
                    onLogicalOperatorChange={this.props.onLogicalOperatorChange}
                    onParenthesesChange={this.props.onParenthesesChange}
                    onAddConditionClick={this.props.onAddConditionClick}
                    onRemoveConditionClick={this.props.onRemoveConditionClick}
                    onComparisonTypeChange={this.props.onComparisonTypeChange}
                    onOperandClick={this.props.onOperandClick}
                    onCopyClick={this.props.onCopyClick}
                    onPasteClick={this.props.onPasteClick}
                    allowPaste={this.props.allowPaste}
                    onClearClick={async (e, condition) => { this.onClearClick(condition, filter); }}
                    onReorderConditions={(condition) => { this.onReorderConditions(condition, filter); }} />

                <div className="code-block">
                    <span className="code">{this.props.details.keyword2}</span>
                </div>

                <ErrorList errors={filter.errors} className="mt-2" />

                <ReportComponentStatus
                    reportType={this.props.reportConfig.type}
                    lastUpdatedTime={filter.lastUpdatedTime}
                    isReadOnly={this.props.isReadOnly} />
            </>
        );
    }

    onAddFilterClick(): void {
        if (this.props.reportConfig.filters.length > 0) {
            this.setState({ showPopup: true });
        }
        else {
            const name = `Filter-${this.props.reportConfig.filters.length + 1}`;
            this.props.onAddStatementClick(name, () => { });
        }
    }


    async validateInsertBeforeAfter(number: number, isInsertAfter: boolean) {
        return await reportComponentBuildersHelper.validateAction(
            number,
            isInsertAfter,
            this.props.reportConfig.filters as IdNameAndNumber[],
            ComponentType.Filter,
            ActionType.Add,
            this.props.reportConfig);
    }

    prepareOptionsFromFilters(): SelectSearchOption[] {

        let options: SelectSearchOption[] = [];
        this.props.reportConfig.filters.forEach((filter) => {
            options.push({
                name: filter.name,
                value: filter.name,
                items: [{ name: filter.number.toString(), value: filter.number.toString() }]
            });
        });

        return options;
    }

    render(): JSX.Element {

        const filterOptions = this.prepareOptionsFromFilters();

        return (
            <>
                <ReportLogicList
                    onDropZoneDrop={this.onDropBetweenFilters}
                    isWaiting={this.props.isWaiting}
                    items={this.props.statements}
                    columns={getColumns(
                        this.onNameChange,
                        this.onBusinessDescriptionChange,
                        this.onStatusChange,
                        this.onBespokeToggleClick,
                        this.props.onRemoveStatementClick,
                        this.onCommentClick,
                        this.onActionItemClick,
                        this.reorder,
                        this.getCommentCount,
                        this.getActionItemCount,
                        this.props.isReadOnly,
                        this.props.reportConfig.id as number)}
                    getContent={this.getConditionContent}
                    getKey={f => f.number}
                    createHtmlId={f => reportConfigNavigation.buildFilterId(f.number)} />
                {
                    !this.props.isReadOnly &&
                    !this.props.isWaiting &&
                    (this.props.reportConfig.type !== reportType.accuracy ||
                        (this.props.reportConfig.type === reportType.accuracy && this.props.reportConfig.filters.length === 0)) &&

                    <div className="mt-4 mb-4">
                        <button onClick={this.onAddFilterClick} className="btn btn-light">+ Filter</button>
                    </div>
                }
                {
                    this.state.showPopup ?
                        <InsertAtPositionModal
                            title='New Filter'
                            onSaveClick={this.onFilterConfiguredInPopup}
                            name='Filter'
                            dropdownOptions={filterOptions}
                            onClose={() => { this.setState({ showPopup: false }); }}
                            defaultDropdownOption={filterOptions[0]}
                            defaultDropdownOptionAlwaysLastOne={true}
                            validateFunction={this.validateInsertBeforeAfter}
                        />
                        : null
                }
            </>);
    }

}

export default FilterBuilder;
